<script setup lang="ts">
import { HomeButton } from '@/components/home'
import { computed, toRef } from 'vue'
import { usePuzzle } from '@/composables/game/puzzles'
import type { RewardLiveOp } from '@/types/shared/player-config'
import PuzzleIcon from '@/assets/images/puzzle-button-icon.png'
import { twMerge } from 'tailwind-merge'

const props = withDefaults(defineProps<{
  puzzle: RewardLiveOp
  containerClass?: string
}>(), {
  containerClass: '',
})

const puzzleRef = toRef(() => props.puzzle)

const { countdownForEventEnd, showPuzzle } = usePuzzle(puzzleRef)

const backgroundGradients = [
  'bg-[linear-gradient(180deg,#E73131_0%,#1C2A2B_100%)]',
  'bg-[linear-gradient(-40deg,#D93B34_22%,#FEF470_85%)]',
  'bg-[linear-gradient(-40deg,#280085_22%,#FEF470_85%)]',
  'bg-[linear-gradient(-40deg,#00FFBB_22%,#FEF470_85%)]',
  'bg-[linear-gradient(-40deg,#2D0200_22%,#FEF470_85%)]',
  'bg-[linear-gradient(-40deg,#FF27E2_22%,#FEF470_85%)]',
]

const gradientIndex = computed(() => (props.puzzle.id - 1) % backgroundGradients.length)
const currentBackgroundGradient = computed(() => backgroundGradients[gradientIndex.value])
</script>

<template>
  <HomeButton
    variant="bottom"
    v-if="showPuzzle"
    no-border
    label="Jigsaw"
    :countdown="{ value: countdownForEventEnd, dangerThreshold: 3600 * 3 }"
    :button-class="twMerge('overflow-hidden bg-transparent', containerClass)"
  >
    <div
      class="size-[27px]"
      :class="currentBackgroundGradient"
      :style="{
        maskImage: `url(${PuzzleIcon})`,
        maskSize: 'contain',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskImage: `url(${PuzzleIcon})`,
        WebkitMaskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
      }"
    />
  </HomeButton>
</template>
